export default (router, store) => {
    router.beforeEach((to, from, next) => {

        if (to.meta.permissions && !store.state.authenticated) {
            return next('/')
        }

        if (to.meta.permissions && to.meta.permissions.length && store.state.permissions && store.state.permissions.findIndex(permission => to.meta.permissions.includes(permission)) < 0) {
            return next('/')
        }

        next()
    })
}
